import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared/state';

type CompanyInformationModalAnalyticIds = {
  elevatorPitchAnalyticId: string;
  companyUrlAnalyticId: string;
};

export const useCompanyInformationModalAnalyticIds = (): CompanyInformationModalAnalyticIds => ({
  elevatorPitchAnalyticId: useAnalyticId(AnalyticIdentifier.GAAP_CAP_ELEVATOR_PITCH_INPUT),
  companyUrlAnalyticId: useAnalyticId(AnalyticIdentifier.GAAP_CAP_COMPANY_URL_INPUT),
});
